'use strict';

angular.module('substoreApp', [
    'ngSanitize',
    'ngRoute',
    'pascalprecht.translate',
    'ui.bootstrap',
    'substoreApp.filters',
    'substoreApp.services',
    'substoreApp.directives',
    'substoreApp.controllers'
])

    .config(['$translateProvider', function ($translateProvider) {
        // Load i18n message files asynchronously on demand:
        $translateProvider.useLoader('asyncI18nLoader');
        $translateProvider.preferredLanguage("de");
        $translateProvider.useMissingTranslationHandlerLog();
        $translateProvider.useMissingTranslationHandler('missingTranslation');
    }])

    .factory('missingTranslation', function ($log) {
        var missingTranslations = {};
        return function(translationId) {
            if (!missingTranslations[translationId]) {
                missingTranslations[translationId] = true;
                $log.debug("Missing translation: ", translationId);
            }
        };
    })

    .factory('pendingRequestsHttpInterceptor', [ '$q', '$location', '$timeout', '$log', 'sessionData', function ($q, $location, $timeout, $log, sessionData) {
        function isBlocking(config) {
            var url = config.url;
            if (typeof url !== 'string')
                url = url[0];

            //$log.debug("pendingRequestsHttpInterceptor.isBlocking", config, config && config.url, url);

            // white list for non-blocking calls
            if (url.match(".*productAvailability.*"))
                return false;

            return true;
        }

        var delayWaitAn;
        return {
            'request': function (config) {
                //$log.debug("pendingRequestsHttpInterceptor.request: ", config, config && config.url);

                if (isBlocking(config)) {
                    sessionData.transient.pendingRequests++;
                    if (delayWaitAn) {
                        $timeout.cancel(delayWaitAn);
                    }
                    delayWaitAn = $timeout(function () { //delay wait animation so its only visible for really long wait time
                        sessionData.transient.isLoading = true;
                    }, 100);
                }

                return config || $q.when(config);
            },

            'requestError': function (rejection) {
                //$log.debug("pendingRequestsHttpInterceptor.requestError: ", rejection, rejection.config, rejection.config && rejection.config.url);

                if (isBlocking(rejection.config)) {
                    sessionData.transient.pendingRequests--;
                }

                return $q.reject(rejection);
            },

            'response': function (response) {
                //$log.debug("pendingRequestsHttpInterceptor.response: ", response, response.config, response.config && response.config.url);

                if (isBlocking(response.config)) {
                    sessionData.transient.pendingRequests--;
                    if (sessionData.transient.pendingRequests === 0) {
                        $timeout.cancel(delayWaitAn);
                        sessionData.transient.isLoading = false;
                    }
                }

                return response || $q.when(response);
            },

            'responseError': function (rejection) {
                //$log.debug("pendingRequestsHttpInterceptor.responseError: ", rejection, rejection.config, rejection.config && rejection.config.url);

                if (isBlocking(rejection.config)) {
                    sessionData.transient.pendingRequests--;
                    if (sessionData.transient.pendingRequests === 0) {
                        $timeout.cancel(delayWaitAn);
                        sessionData.transient.isLoading = false;
                    }

                    //Firefox triggers the onerror callback of any pending XHR when moving away of the current page (e.g. reloading), status -1 is returned
                    // https://github.com/angular/angular.js/issues/14219
                   if (rejection.status != -1) {
                        $location.path("error");

                   }
                    return $q.reject(rejection);
                }


            }

        };
    }])

    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('pendingRequestsHttpInterceptor');
    })

    .run(['$location', '$compile', '$rootScope', '$window', '$translate', 'uiservice', 'sessionData', '$http', function ($location, $compile, $rootScope, $window, $translate, uiservice, sessionData, $http) {

        function loadTitle() {
            // 3.2.3 Page Title
            // Note: we cannot use angularjs binding for <title> element, because it doesn't work with IE8
            // Note: title is changed in the masterController.js when breadcrumb is changed
            $translate('title').then(function (title) {
                $window.document.title = title;
            });
        }

        function goErrorWithFault(code) {
            if (code)
                sessionData.fault = { code: code };
            $location.url('/error/' + sessionData.fault.code);
            $location.replace();
        }

        // make body visible
        function showBody() {
            if (self === top) {
                angular.element(document.querySelector('#bodymain')).css('display', 'inherit');
            } else {
                top.location = self.location;
            }
            loadTitle();
        }

        function handleErrorResponse(response, /*optional*/ errorInURL) {
            if (response && response.status == 500 && response.data && response.data.head && response.data.head.fault) {
                // we got a fault from server
                sessionData.fault = response.data.head.fault;
                // maybe we got a sessionId, too. (it's optional during a fault)
                sessionData.sessionId = response.data.head.sessionId;
                // and maybe we got a csrfProtectionToken, too
                if (response.data.data) {
                    sessionData.csrfProtectionToken = response.data.data.csrfProtectionToken;
                    // The /createSession and /getSession requests can even return regular dialogStaticData
                    // together with the fault (e.g. for language, natCoName, wpid etc.)
                    if (response.data.data.dialogStaticData) {
                        sessionData.mergeWith(response.data.data.dialogStaticData);
                    }
                }
                // store session data
                sessionData.storeSessionData();
                $http.defaults.headers.common['CSRF-TOKEN'] = sessionData.csrfProtectionToken;
                window.onfocus = window.onbeforeunload = sessionData.storeSessionData;
                sessionData.notifyDataAvailable();
                // display session data error
                goErrorWithFault(errorInURL);
            } else {
                // other HTTP errors
                goErrorWithFault('UNEXPECTED_ERROR');
            }
            showBody();
        }

        var cryptoticket = $location.search().ct;
        var servicepartner = $location.search().sp;
        var errorInURL = $location.search().error || ($location.path().substring(0, 7) == '/error/' ? $location.path().substring(7) : null);
        var psn = $location.search().psn;
        var page = $location.search().page;

        if (!cryptoticket) {
            // if no cryptoticket is given, then we should already have sessionData
            if (sessionData.loadSessionData() && sessionData.sessionId) {
                // Workaround: try to extract orderCallId from url if we don't have any, and put it into sessionData.transient.
                // This is a hack, because it would be better to store the orderCallId in the non-transient (persistent) part
                // of sessionData so that it survives browser reloads.
                if (!sessionData.transient.orderCallId) {
                    // 1. orderCallId could be given as search parameter. This happens if a 3rd part authentication site
                    // redirects back to us (see ReturnFromExternalRequestProcessor)
                    sessionData.transient.orderCallId = $location.search().orderCallId;
                }
                if (!sessionData.transient.orderCallId) {
                    // 2. orderCallId could be inside the Angular hash, e.g. "#/ordersummary/<subscriptionTemplateId>/<orderCallId>/<someOtherStuff>
                    var match = /\/ordersummary\/[^\/]+\/([^\/]+)/.exec($location.path());
                    if (match) sessionData.transient.orderCallId = match[1];
                }
                // call /getSession to retrieve existing session data
                uiservice.getSession({ sessionId: sessionData.sessionId, orderCallId: sessionData.transient.orderCallId, subscriptionTemplateId: sessionData.transient.subscriptionTemplateId, lang: sessionData.dialogStaticData.language, wpId: sessionData.dialogStaticData.wholesalePartnerId },
                    function success(response) {
                        // save session data
                        sessionData.sessionId = response.head.sessionId;
                        sessionData.dialogStaticData = response.data.dialogStaticData;
                        sessionData.transient.subscriptionTemplateId = response.data.subscriptionTemplateId;
                        sessionData.storeSessionData();
                        $http.defaults.headers.common['CSRF-TOKEN'] = sessionData.csrfProtectionToken;
                        window.onfocus = window.onbeforeunload = sessionData.storeSessionData;
                        sessionData.notifyDataAvailable();
                        // if parameter error has been given in URL show error even if getSession return success
                        if (errorInURL) {
                            goErrorWithFault(errorInURL);
                        }
                        $location.replace();
                        showBody();
                    },
                    function error(response) {
                        handleErrorResponse(response, errorInURL);
                    });
            } else {
                // No cryptoticket given, and session data could not be loaded: probably wrong URL parameters, or wrong state:
                // Display either persisted error, or error code given by 'error' parameter.
                // But first try to load dialogStaticData without sessionId. We need the dialogStaticData because of natCoName
                // and availableLanguages
                uiservice.getSession({ sessionId: null, orderCallId: null, subscriptionTemplateId: null, lang: sessionData.dialogStaticData.language, wpId: sessionData.dialogStaticData.wholesalePartnerId },
                    function success(response) {
                        // success() should neven been called, because the /getSession request without sessionId
                        // always returns an HTTP 500 error with fault section
                        goErrorWithFault('UNEXPECTED_ERROR');
                        showBody();
                    },
                    function error(response) {
                        // The error response should have a data fault section with code EXPIRED_SESSION
                        // (because we didn't sent a sessionId) and a data section with dialogStaticData only.
                        // This will be handled by the following method.
                        handleErrorResponse(response, errorInURL);
                    });
            }
        } else {
            uiservice.createSession({ ct: cryptoticket, sp: servicepartner, chainId: uuid.v4(), psn: psn, page: page },
                function success(response) {
                    sessionData.sessionId = response.head.sessionId;
                    sessionData.csrfProtectionToken = response.data.csrfProtectionToken;

                    // save session data
                    sessionData.dialogStaticData = response.data.dialogStaticData;
                    sessionData.transient.subscriptionTemplateId = response.data.subscriptionTemplateId;
                    // store session data
                    sessionData.storeSessionData();
                    $http.defaults.headers.common['CSRF-TOKEN'] = sessionData.csrfProtectionToken;
                    window.onfocus = window.onbeforeunload = sessionData.storeSessionData;
                    sessionData.notifyDataAvailable();

                    // further routing: respect showPage depending on current workflow
                    switch (response.data.showPage) {
                        case 'CATALOGUE' :
                            $location.path("/catalogue");
                            break;
                        case 'MYPRODUCTSPAGE' :
                            $location.path("/myproducts/" + (sessionData.transient.subscriptionTemplateId ? sessionData.transient.subscriptionTemplateId : ""));
                            break;
                        case 'PRODUCTDETAILPAGE' :
                            $location.path("/productdetails/" + sessionData.transient.subscriptionTemplateId);
                            sessionData.transient.deeplinkedPage = response.data.showPage;
                            break;
                        case 'ORDERSELECTIONPAGE' :
                            $location.path("/orderselection/" + sessionData.transient.subscriptionTemplateId);
                            break;
                        case 'OPTIN' :
                            $location.path("/ordersummary/" + sessionData.transient.subscriptionTemplateId + "/" + response.data.orderCallId + "/optin");
                            break;
                        // temporary 18.2.1 solution part #2: handle deep link for product change
                        case 'PRODUCTCHANGEPAGE' :
                            $location.path("/productchangeselection/" + sessionData.transient.subscriptionTemplateId + "/" + response.data.uniqueSubscriptionId);
                            break;
                        // end of temporary 18.2.1 solution part #2
                        default:
                            goErrorWithFault("UNEXPECTED_ERROR");
                            break;
                    }
                    // remove all url params
                    $location.search({});
                    $location.replace();
                    //show something
                    showBody();
                },
                function error(response) {
                    handleErrorResponse(response);
                }
            );
        }
    }]);
